import { useEffect } from "react";
import { useListingFormContext } from "@/context/ListingFormContext";

export const useFormTouchDetection = (formSelector: string) => {
  const { setValidateOnChange } = useListingFormContext(); // Removed setFormTouched

  useEffect(() => {
    // Track which field is currently focused
    let currentlyFocusedField: Element | null = null;

    const handleFocusIn = (e: FocusEvent) => {
      // Keep track of which field is focused
      currentlyFocusedField = e.target as Element;

      // Disable validation while user is entering data
      setValidateOnChange(false);
    };

    const handleFocusOut = (e: FocusEvent) => {
      // Only validate a field when focus leaves it (not the whole form)
      if (currentlyFocusedField && currentlyFocusedField === e.target) {
        // setFormTouched(true); // No longer needed as formTouched is derived

        // Enable validation for just this field
        // Use a timeout to ensure the value is updated before validation
        setTimeout(() => {
          setValidateOnChange(true);
        }, 100);

        // Clear the currently focused field
        currentlyFocusedField = null;
      }
    };

    // Find the form element using the selector
    const formElement = document.querySelector(formSelector);

    if (formElement) {
      formElement.addEventListener("focusin", handleFocusIn);
      formElement.addEventListener("focusout", handleFocusOut);

      return () => {
        formElement.removeEventListener("focusin", handleFocusIn);
        formElement.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [setValidateOnChange, formSelector]); // Removed setFormTouched from dependencies
};
